export default __webpack_public_path__ + "static/media/gallery-wip-electronics_02.40d86f9c.jpg";